/**
 * Scroll to top when using pagination
 */
export const partnersFeedPager = ({ elWrap, elPosts }) => {
	elWrap.querySelector('.partners-feed__control--pager').addEventListener('click', (e) => {
		// if this is a page link and we're at mobile
		if (e.target.dataset.page && window.innerWidth < 782) {
			elPosts.scrollIntoView({
				behavior: 'smooth',
			})
		}
	})
}
